import replaceHttpsImg from './repalceHttpsImg'
import LightMobileCall from "@kugou/light-mobilecall";
import event from '../Event/index.js'
import openKugouApp from "@kugou/open-kugou-app"
import Clipboard from 'clipboard'

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
      return window.decodeURIComponent(r[2]);
  }
  return null;
}
//获取url中的所有参数
function getAllUrlParams(){
  var pram = window.location.href.split('?')[1];
  var keyValue = pram ? pram.split('&') : [];
  var obj = {};
  var item = [], key, value;
  for (var i = 0; i<keyValue.length; i++){
    item = keyValue[i].split('=');
    key = item[0];
    value = getQueryString(key);
    obj[key] = value;
  }
  return obj;
}

function json2keyval( params ) {
  var thisParam = "";
  for ( var Key in params ) {
    if ( thisParam ) {
      thisParam = thisParam + "&" + Key + "=" + encodeURIComponent(params[ Key ]) + "";
    } else {
      thisParam = Key + "=" + params[ Key ] + "";
    }
  }
  return thisParam;
}

//字符串截取
export const textSub = function ( text, n ) {
  var r = /[^\x00-\xff]/g;
  if ( text.replace( r, "mm" ).length <= n ) return text;
  var m = Math.floor( n / 2 );
  for ( var i = m; i < text.length; i++ ) {
    if ( text.substr( 0, i ).replace( r, "mm" ).length >= n ) {
      return text.substr( 0, i ) + '...';
    }
  }
  return text;
};

export const utilService = {
    /**
     * 时间格式化
     * 
     * @param {Date} date 
     * @param {String} fmt 
     */
    dataFormat: function (date, fmt) {
        var o = {
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((date.getMonth() + 3) / 3),
            "S": date.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            } 
        }
        return fmt;
    },

    /**
     * 将 yyyy-MM-dd hh:mm:ss.m 格式的时间成 Date 对象
     * 
     * @param {String} str
     * @returns Date
     */
    stringToDate: function(str) {
        str = str.substring(0, 19);
        str = str.replace(/-/g, '/'); 
        return new Date(str);
    },

    /**
     * 列表去重
     * 
     * @param {Array} arr 列表
     * @param {String} field 根据列表对象的某一个属性去重，比如 user对象的id属性，传 "id"
     */
    uniqArry: function(arr, field) {
        var map = {};
        var res = [];
        for (var i = 0; i < arr.length; i++) {
            if (!map[arr[i][field]]) {
                // arr[i][field] 没有存在
                res.push(arr[i]);
                map[arr[i][field]] = true; 
            } else {
                // arr[i][field] 存在
                map[arr[i][field]] = false; 
            }
        }
        return res;
    },

    // 判断是否为空
    isEmpty: function(obj) {
        if (typeof obj != 'undefined' && obj != null && obj != "") {
            return false;
        } else {
            return true;
        }
    },

    // 去掉前后空格
    trim: function(str) {  
        return str.replace(/^(\s|\u00A0)+/,'').replace(/(\s|\u00A0)+$/,'');  
    },

    // 动态加载 js
    loadScript: function (url, args, callback, scriptSet) {
        var params = args || "";
        var loadtime = 0;
        var timer = null;
        if (args && (typeof args === "object")) {
            var str = "";
            for (var i in args) {
                str += i + "=" + args[i] + "&";
            }
            params = str.substr(0, str.length - 1);
        };
        params = params.trim();
        var script = document.createElement("script");
        script.type = 'text/javascript';
        scriptSet && scriptSet(script);
        script.src = url + (params ? "?" + params : "");
        script.onload = script.onreadystatechange = function () {
            if( loadtime > 8 ){
                return;
            }
            timer && clearInterval(timer)
            if (!this.readyState || (this.readyState == "complete" || this.readyState == "loaded")) {
                callback && callback();
                script.onreadystatechange = script.onload = null;
                script = null;
            }
        };
        script.onerror = function (e) {
            callback && callback(e);
        };
        document.getElementsByTagName("head")[0].appendChild(script);
        timer = setInterval(function(){
            loadtime ++;
            if( loadtime > 8 ){
                callback && callback('load error');
                timer && clearInterval(timer)
            }
        }, 1000)
    },

    Cookie: {
        write: function (name, value, exp, path, domain, secure) {
            if (!/^\w*$/.test(name)) {
                alert("cookie格式不正确");
            }
            if (/; /.test(value)) {
                alert("cookie格式不正确");
            }
            var cookieValue = name + "=" + value;
            if (exp) {
                var dt = new Date();
                dt.setTime(dt.getTime() + (exp * 1000));
                cookieValue += "; expires=" + dt.toGMTString();
            }
            if (path) {
                cookieValue += "; path=" + path;
            }
            if (domain) {
                cookieValue += "; domain=" + domain;
            }
            if (secure) {
                cookieValue += "; secure";
            }
            document.cookie = cookieValue;

        },
        rewriteKey: function (name, key, keyVal, exp, path, domain, secure) {
            var str = key;
            if (keyVal) {
                var cookie = this.read(name);
                var reg = new RegExp("\\b" + key + "=([^&]*)\\b", "g");
                str = cookie.replace(reg,
                    function (m1, m2) {
                        return m1.replace(m2, keyVal);
                    })
            }
            if (/^\d+(s|m|h|d)$/i.test(exp)) {
                if (/^\d+s$/i.test(exp)) {
                    this.setSec(name, str, (exp.replace(/s$/i, "")), path, domain, secure);
                }
                if (/^\d+m$/i.test(exp)) {
                    this.setMin(name, str, (exp.replace(/m$/i, "")), path, domain, secure);
                }
                if (/^\d+h$/i.test(exp)) {
                    this.setHour(name, str, (exp.replace(/h$/i, "")), path, domain, secure);
                }
                if (/^\d+d$/i.test(exp)) {
                    this.setDay(name, str, (exp.replace(/d$/i, "")), path, domain, secure);
                }
            } else {
                this.write(name, str, exp, path, domain, secure);
            }
        },
        setDay: function (name, value, exp, path, domain, secure) {
            this.write(name, value, (exp * 24 * 60 * 60), path, domain, secure);
        },
        setHour: function (name, value, exp, path, domain, secure) {
            this.write(name, value, (exp * 60 * 60), path, domain, secure);
        },
        setMin: function (name, value, exp, path, domain, secure) {
            this.write(name, value, (exp * 60), path, domain, secure);
        },
        setSec: function (name, value, exp, path, domain, secure) {
            this.write(name, value, (exp), path, domain, secure);
        },
        read: function (name, key, isJSON) {
            var cookieValue = "";
            var arrStr = document.cookie.split("; ");
            for (var i = 0; i < arrStr.length; i++) {
                var temp = arrStr[i].match(/^(\w+)=(.+)$/);
                if (temp && temp.length > 1 && temp[1] == name) {
                    cookieValue = temp[2];
                    break;
                }
            }
            if (cookieValue == "") {
                return null;
            } else {
                if (key) {
                    if (!isJSON) {
                        return new utilService.Param().parse(cookieValue)[key];
                    } else {
                        return JSON.parse(cookieValue)[key];
                    }
                }
                return cookieValue;
            }
        },
        remove: function (name, path, domain) {
            var cookie = name + "=";
            if (path) {
                cookie += '; path=' + path;
            }
            if (domain) {
                cookie += ';domain=' + domain;
            }
            cookie += '; expires=Fri, 02-Jan-1970 00:00:00 GMT';
            document.cookie = cookie;
        },
    },

    Param: function() {
        var arr = [];
        var o = {};
        this.parse = function(str) {
            alert(str);
            var a = str.split("&");
            for (var i = 0,
            l = a.length; i < l; i++) {
                var k = a[i].split("=");
                o[k[0]] = k[1];
            }
            return o;
        };
        this.toString = function(filter) {
            filter = filter || "&";
            return arr.join(filter);
        };
        this.add = function(key, val) {
            var prm = key + "=" + val;
            arr.push(prm);
            return this;
        }
    },

    // 获取url的参数值
    getUrlParam: function(key) {

        let urlSearch = ""; // url ? 部分

        let url = window.location.href;
        let indexSearch = url.indexOf("?");
        let indexHash = url.indexOf("#");

        if (indexSearch >= 0 && indexHash == -1) {
            // 只有 search
            urlSearch = url.substr(indexSearch);
        }
        if (indexHash >= 0 && indexSearch == -1) {
            // 只有 hash
            urlSearch = "";
        }
        if (indexHash >= 0 && indexSearch >= 0 && indexSearch > indexHash) {
            // 同时有 search 和 hash, # 在 ? 前面
            urlSearch = url.substr(indexSearch);
        }
        if (indexHash >= 0 && indexSearch >= 0 && indexHash > indexSearch) {
            // 同时有 search 和 hash, ? 在 # 前面
            urlSearch = url.substr(indexSearch, indexHash - indexSearch);
        }


        var theRequest = {};
        if (urlSearch.indexOf("?") != -1) {
            var str = urlSearch.substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            }
        }
        return theRequest[key];
    },

    // 将对象变成 key=value&key=value 的字符串
    objToParamStr: function(paramObj = {}) {
        console.log('paramObj',paramObj)
        let res = "";
        Object.keys(paramObj).forEach(function(key) {
            if(res == "") {
                res += (key + "=" + paramObj[key]);
            } else {
                res += ("&" + key + "=" + paramObj[key]);
            }
        });
        return res;
    }
};

/**
 * 当前系统配置
 */
export const os = ( function ( ) {
  let ua = window.navigator.userAgent;
  let osInner = {},
    android = ua.match( /(Android);?[\s\/]+([\d.]+)?/ ),
    ipad = ua.match( /(iPad).*OS\s([\d_]+)/ ),
    ipod = ua.match( /(iPod)(.*OS\s([\d_]+))?/ ),
    iphone = !ipad && ua.match( /(iPhone\sOS)\s([\d_]+)/ ),
    SafariBrowser = new RegExp( "Safari/", "gi" ).test( ua ),
    UCBrowser = new RegExp( "UCBrowser", "gi" ).test( ua ),
    MQQBrowser = new RegExp( "MQQBrowser", "gi" ).test( ua ),
    MicroMessenger = new RegExp( "MicroMessenger", "gi" ).test( ua ),
    QQ = new RegExp( "QQ/", "gi" ).test( ua ),
    Weibo = new RegExp( "Weibo", "gi" ).test( ua ),
    Mobile = ua.toLowerCase().indexOf( "mobile" ) !== -1;

  if ( android ) {
    osInner.android = true;
    osInner.version = android[ 2 ];
  }
  if ( iphone && !ipod ) {
    osInner.ios = osInner.iphone = true;
    osInner.version = iphone[ 2 ].replace( /_/g, "." );
  }
  if ( ipad ) {
    osInner.ios = osInner.ipad = true;
    osInner.version = ipad[ 2 ].replace( /_/g, "." );
  }

  osInner.SafariBrowser = SafariBrowser;
  osInner.UCBrowser = UCBrowser;
  osInner.MQQBrowser = MQQBrowser;
  osInner.MicroMessenger = MicroMessenger;
  osInner.QQ = QQ;
  osInner.Weibo = Weibo;
  osInner.Mobile = Mobile;
  return osInner;
} )();

function updateUrl(url, key) {
    var key = (key || 'time') + '=';         //默认是"t"
    var reg = new RegExp(key + '\\d+');        //正则：t=1472286066028
    var timestamp = +new Date();
    if (url.indexOf(key) > -1) { //有时间戳，直接更新
        return url.replace(reg, key + timestamp);
    } else {          //没有时间戳，加上时间戳
    if (url.indexOf('\?') > -1) {
        var urlArr = url.split('\?');
        if (urlArr[1]) {
            return urlArr[0] + '?' + key + timestamp + '&' + urlArr[1];
        } else { return urlArr[0] + '?' + key + timestamp; }
    } else {
        if (url.indexOf('#') > -1) {
            return url.split('#')[0] + '?' + key + timestamp + '/' + window.location.hash;
        } else { return url + '?' + key + timestamp + '/'; }
    }
    }
}

function refreshPage(){
    window.location.reload();
    if(os.android){
        window.location.href = updateUrl(window.location.href)
        console.log('android refresh 1');
        //http://doc.kugou.net/showdoc-master/web/#/5?page_id=159 安卓刷新webview
        LightMobileCall.mobileCall(248, {reloadIndex: 0})
        console.log('android refresh 2');
    }
}

//风控
function riskManagement(res, params){
    window.$Msg("您操作太频繁了，请稍后再试")
    console.log('风控');
    let eventid_1 = res.headers["ssa-code"];
    let mid_1 = window.$userInfo.mid_v2 || window.$userInfo.mid || res.headers[ "ssa-hmid" ];
    let url = window.location.href
    //未编码的链接访问不了
    //https://h5.kugou.com/apps/musician-enter/build/index.html#/enter/{"name":"%E5%91%A8%E6%9D%B0%E7%91%9E","pic":"https://tme-yyr-1253690380.cos.ap-guangzhou.myqcloud.com/qqmusic/file/d/28ffd6be8fcead2d/9/5481d996b42c722d8f1d390431370839.jpg","id":221527,"status":0,"platform":4,"type":0,"area":0,"identity":0,"genre":0,"introduce":null}
    if(~window.location.href.indexOf('/enter') && params){
        url = 'https://h5.kugou.com/apps/musician-enter/build/index.html#/enter/' + window.encodeURIComponent(JSON.stringify(params))
    }
    console.log(url, '风控跳转链接');
    if (window.KgUser) {
        window.rejectRes = null
        window.LC.mobileCall(710, { type: 1 });
        console.log(eventid_1, mid_1, );
        let data = {
            eventid: eventid_1,
            userid: window.$userInfo.userid,
            appid: 1058,
            mid: mid_1,
            openWith: "iframe",
            callback: function(res){
                console.log('风控验证结果', res);
            }
            //url: url
        }
        console.log(data, '风控验证1');
        window['KgUser'].antiBrushH5(data);
    }else {
        utilService.loadScript("https://staticssl.kugou.com/common/js/min/login/kguser.v2.min.js?v=20190313", '', function (e) {
            if (e) return;
            window.rejectRes = null
            window.LC.mobileCall(710, { type: 1 });
            let data = {
                eventid: eventid_1,
                userid: window.$userInfo.userid,
                appid: 1058,
                mid: mid_1,
                openWith: "iframe",
                callback: function(res){
                    console.log('风控验证结果', res);
                }
                //url: url
            }
            console.log(data, '风控验证2');
            window['KgUser'].antiBrushH5(data);
        });
    }
}

export function formatDate(date) {
  /* eslint no-confusing-arrow: 0 */
  const pad = n => n < 10 ? `0${n}` : n;
  const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  return `${dateStr}`;
}

/* 腾讯拖拽验证组件 */
export const getIdentifyCodeWithCaptcha = (options = {}) => {

  if (!window) {
    return Promise.resolve({})
  }

  return new Promise((resolve, reject) => {
    try {
        if (window.TencentCaptcha) {
            const testAppid = '2032158066'; // 测试环境：ysit~ysit5
            const onlineAppid = '2013326277'; // 线上环境 ypre、y
            const appid = getQueryString("debug") && getQueryString("testAppid") ? testAppid : onlineAppid;
            new window.TencentCaptcha(appid, (captchaParam) => {
                if (+captchaParam.ret === 0) {
                    resolve(captchaParam || {});
                }
                reject(captchaParam);
            }, options).show();
        } else {
            event.emit('loading', true)
            utilService.loadScript("https://ssl.captcha.qq.com/TCaptcha.js", '', function (e) {
                event.emit('loading', false)
                if (e) {
                    window.$Msg("加载图形验证失败，请稍后刷新重试~")
                    return
                };
                const testAppid = '2032158066'; // 测试环境：ysit~ysit5
                const onlineAppid = '2013326277'; // 线上环境 ypre、y
                const appid = getQueryString("debug") ? testAppid : onlineAppid;
                new window.TencentCaptcha(appid, (captchaParam) => {
                    if (+captchaParam.ret === 0) {
                        resolve(captchaParam || {});
                    }
                    reject(captchaParam);
                }, options).show();
            });
        }
    } catch (error) {
        reject(error);
    }
 });
};

export function openKg() {
    openKugouApp("303", 9, 0, {
        url: window.location.href,
        title: document.title
    })
}

function getUuiD(randomLength){
 return Number(Math.random().toString().substr(2,randomLength) + Date.now()).toString(36)
}

export function openKf(){
    let userInfo = window.$userInfo;
    function kf(userInfo){
        window._echat=window._echat||function(){(window._echat.q=window._echat.q||[]).push(arguments)};window._echat.l=+new Date;
        if(!window._kfInit){
            window._kfInit = true;
            window._echat('initParam', { companyId: 531933, echatTag: "app"});
        }
        
        let metaData = window.WECHAT.wxEncrypt(`<xml>
        <uid><![CDATA[${userInfo.kugouID && parseInt(userInfo.kugouID) != 0 ? userInfo.kugouID : getUuiD(10)}]]></uid>
        <name><![CDATA[${userInfo.nickName}]]></name>
        <memo><![CDATA[平台=${LightMobileCall.isIOS?'苹果':'安卓'};酷狗版本=${userInfo.version};操作系统版本=${userInfo.osVersion};设备型号=${userInfo.deviceType};网络类型=${userInfo.net};是否为VIP=${userInfo.isVip};来源=移动端入驻页]]></memo>
        </xml>`,"MDU0NjgxMjA3OTQ3NDc3ZWEwZWJkNTExNjlkMzM5ODI","249433453148940A81EF70AE375522E4");

        //let myData = encodeURIComponent(`platform=${LightMobileCall.isIOS?'苹果':'安卓'}&version=${userInfo.version}&osVersion=${userInfo.osVersion}&deviceType=${userInfo.deviceType}&net=${userInfo.net}&isVip=${userInfo.isVip}&from=移动端后台`);

        let url = `https://www.echatsoft.com/visitor/mobile/chat.html?companyId=531933&echatTag=app&metaData=${metaData.toString()}`
        console.log('客服链接：', url);

        LightMobileCall.mobileCall(123, {
            browser: 10,
            url,
            title: '在线客服',
            hasBar: 0
        })
    }

    if(!window.WECHAT || !window._echat){
        event.emit('loading', true);
        utilService.loadScript(('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.echatsoft.com/visitor/echat.js', '', (err1)=>{
            if(err1){
                event.emit('loading', false);
                window.$Msg("网络错误，请稍后刷新重试~");
                return;
            }
            let url = window.location.origin + window.location.pathname.replace("index.html","aes.js")
            utilService.loadScript(url, '', (err2)=>{
                if(err2){
                event.emit('loading', false);
                window.$Msg("网络错误，请稍后刷新重试~");
                return;
                }
                event.emit('loading', false);
                kf(userInfo)
            })
        }, (script)=>{
            script.async = true;
            script.id = 'echatmodulejs';
            script.setAttribute('charset','UTF-8');
        })
    }else{
        kf(userInfo)
    }
}

export function handleClipboard(text, event, scb, fcb){
    const clipboard =  new Clipboard(event.target,{
        text:()=>text
    })
    clipboard.on('success',() => {
        scb && scb();
        clipboard.destroy();
    })
    clipboard.on('error',() =>{
        fcb && fcb();
        clipboard.destroy();
    })
    clipboard.onClick(event)
}

export {
  getQueryString,
  getAllUrlParams,
  json2keyval,
  replaceHttpsImg,
  refreshPage,
  riskManagement
}
